import { render, staticRenderFns } from "./ShortVideo.vue?vue&type=template&id=055a0120&"
import script from "./ShortVideo.vue?vue&type=script&lang=js&"
export * from "./ShortVideo.vue?vue&type=script&lang=js&"
import style0 from "./ShortVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055a0120')) {
      api.createRecord('055a0120', component.options)
    } else {
      api.reload('055a0120', component.options)
    }
    module.hot.accept("./ShortVideo.vue?vue&type=template&id=055a0120&", function () {
      api.rerender('055a0120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/search/components/ShortVideo.vue"
export default component.exports